<template functional>
    <b-badge 
        v-if="props.statusObject[props.valueField] || props.statusObject[props.titleField]" 
        v-b-tooltip="{ title: props.statusObject[props.textField], trigger: 'hover', boundary: 'window', disabled: props.noTooltip }"
        :variant="(props.bare ? 'bare-' : (props.gray ? 'gray-' : 'soft-')) + props.statusObject.color_variant"
        :class="[props.textUppercase ? 'text-uppercase' : '']"
        :style="{
            whiteSpace: props.noWrap ? 'nowrap' : 'normal',
            fontSize: props.fontSize ? props.fontSize : '',
        }"
    >  <!-- v-b-tooltip.hover.window :title="props.statusObject[props.textField]" -->
        <!--  variant="soft-secondary"  -->
        <!-- <b-icon 
            v-if="!props.hideIcon"
            :icon="props.statusObject.icon" 
            class="mr-1"
        ></b-icon> -->
        <b-icon 
            v-if="!props.hideIcon"
            icon="record-fill" 
            :variant="props.statusObject.color_variant"            
        ></b-icon>
        <!-- <span :class="`text-${props.statusObject.color_variant}`">&middot;</span> -->
        {{props.statusObject[props.titleField]}}
    </b-badge>
</template>

<script>
// this should work for any status object that has keys for 'value', 'color_variant', 'title', 'icon' -- pass entire object as prop

export default {
    functional: true,
    name: 'StatusObjectBadge',
    props: {
        statusObject: {
            type: [Object, String],  // added String because sometimes it gets fed an empty String, but the stuff you have in template should be OK with that
            required: true,
        },
        textUppercase: {
            type: Boolean,
            default: false,
        },
        fontSize: {  // should be a string, set like normal CSS size parameter (1rem, large, 1em, etc...)
            type: [String, Number],
            required: false,
        },
        noWrap: {  // set this to true if you want css white-space: nowrap (default for badges)
            // but I changed default to white-space: normal so words will wrap
            type: Boolean,
            default: false,
        },
        noTooltip: {  // don't use tooltip if this is true
            type: Boolean,
            default: false,
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
        titleField: {  // for remapping to something other than 'title'
            type: String,
            default: 'title',
        },
        textField: {  // for remapping to something other than 'text'
            type: String,
            default: 'text',
        },
        valueField: {  // for remapping to something other than 'value' - like 'name' for state_dict
            type: String,
            default: 'value',
        },
        // VARIANT TYPES - bare takes priority, then gray, then default of 'soft'
        bare: {
            type: Boolean,
            default: false,
        },
        gray: {  // if true, we use 'gray-' variant badges
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style>

</style>